import { loadRecaptchaScript } from '@/js/utils/loadRecaptchaScript';

const RECAPTCHA_SITE_KEY = '6LdcBywsAAAAALBG_TzMfpxTVlgNYQfNwfNATkkC';

export type RecaptchaErrorCode = 'captcha-not-loaded' | 'captcha-failed';

export const isRecaptchaErrorCode = (value: unknown): value is RecaptchaErrorCode =>
  value === 'captcha-not-loaded' || value === 'captcha-failed';

export const getRecaptchaErrorMessage = (code: RecaptchaErrorCode): string => {
  if (code === 'captcha-not-loaded') {
    return 'Сервис проверки недоступен. Обновите страницу и попробуйте снова.';
  }

  return 'Не удалось пройти проверку reCAPTCHA. Повторите отправку.';
};

export const getRecaptchaToken = async (): Promise<string> => {
  try {
    await loadRecaptchaScript();
  } catch {
    throw 'captcha-not-loaded';
  }

  return new Promise((resolve, reject: (reason: RecaptchaErrorCode) => void) => {
    const recaptcha = window.grecaptcha;

    if (!recaptcha) {
      reject('captcha-not-loaded');
      return;
    }

    recaptcha.ready(() => {
      recaptcha
        .execute(RECAPTCHA_SITE_KEY, { action: 'submit' })
        .then(resolve)
        .catch(() => reject('captcha-failed'));
    });
  });
};
